export const RESOURCE_TYPE_VEHICLE = 'vehicle';

export const RESOURCE_TYPE_TECHNICIAN = 'technician';
